import script from "./mainCard.vue?vue&type=script&setup=true&lang=js"
export * from "./mainCard.vue?vue&type=script&setup=true&lang=js"

import "./mainCard.vue?vue&type=style&index=0&id=4b4b7483&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b4b7483"]])

export default __exports__